import { faDatabase } from "@fortawesome/pro-solid-svg-icons/faDatabase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Typography } from "@mui/material";
import IconButtonBack from "components/Buttons/IconButtonBack";
import { MuiFilterAdvancedContainer } from "components/MuiExtras/Filter";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiPaper from "components/MuiExtras/MuiPaper";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import { TopicSuggestionDto } from "models/ApiModels";
import * as React from "react";
import { WithTranslation } from "react-i18next";
import TopicAutoComplete from "views/Topic/Components/TopicAutoComplete";

/////////////////////////////////////////////////////////////////////////////////////

interface IKnowledgeTestAnalysisProps {
    disabled?: boolean;
    selectedTopic: TopicSuggestionDto;
    onFilterChange: (topic: TopicSuggestionDto) => void;
}

type Props = IKnowledgeTestAnalysisProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class KnowledgeTestAnalysisFilter extends React.PureComponent<Props> {

    ///
    private onCancel = () => {
        this.props.onFilterChange(null);
    };

    ///
    public render() {
        return (
            <MuiContainer>

                <MuiPaper borderVariant="square" borderColor="success">

                    <Grid container justifyContent="space-between" spacing={2}>
                        <Grid item>
                            <div style={{ width: 64, height: 64 }}>
                                {
                                    this.props.selectedTopic
                                        ? <img src={this.props.selectedTopic.thumbnailUrl} alt={this.props.selectedTopic.label} width={64} height={64} />
                                        : <MuiColor variant="info"><FontAwesomeIcon icon={faDatabase} size="3x" /></MuiColor>
                                }
                            </div>
                        </Grid>
                        <Grid item xs>

                            <Typography variant="button">{this.props.t("Views.Dashboards.KnowledgeTestAnalysis.AnalysisFilter.HeaderTitle")}</Typography>

                            <MuiFilterAdvancedContainer disableMargins>
                                <Grid container justifyContent="space-between" alignItems="flex-end" spacing={1}>
                                    {
                                        this.props.selectedTopic &&
                                        <Grid item>
                                            <IconButtonBack title={this.props.t("Views.Dashboards.Common.ResetSelectedTopic")} onClick={this.onCancel} size="small" />
                                        </Grid>
                                    }

                                    <Grid item xs>
                                        <TopicAutoComplete
                                            margin="dense"
                                            multiple={false}
                                            placeholder={this.props.selectedTopic?.label ?? this.props.t("Views.Dashboards.KnowledgeTestAnalysis.AnalysisFilter.TopicPlaceholder")}
                                            onChange={
                                                (topics) => {
                                                    this.props.onFilterChange(topics.length == 0 ? null : topics[0]);
                                                }
                                            }
                                        />
                                    </Grid>

                                </Grid>
                            </MuiFilterAdvancedContainer>

                        </Grid>
                    </Grid>
                </MuiPaper>
            </MuiContainer>
        );
    }
}

export default KnowledgeTestAnalysisFilter;